import { ReplySupportTicketRequestSchema, ReplySupportTicketResponseSchema } from './reply-support-ticket.schema';
export const replySupportTicketContract = {
    method: 'POST',
    path: '/api/v2/support/tickets/:ticketId/reply',
    description: 'Reply to a support ticket as the customer',
    requestSchema: ReplySupportTicketRequestSchema,
    responseSchema: ReplySupportTicketResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'Ticket not found, or not owned by the caller',
            503: 'Service Unavailable - support backend unreachable'
        }
    }
};

//# sourceMappingURL=reply-support-ticket.contract.js.map